import React from "react";
import Banner from "../components/Banner";
import ServicesSection from "../components/HomePage/ServicesSection";
import AboutSection from "../components/HomePage/AboutSection";
import TestimonialSection from "../components/HomePage/TestimonialSection";
import PricingSection from "../components/HomePage/PricingSection";
import ContactUs from "./ContactUs";
import WorkSection from "../components/HomePage/WorkSection";
import FAQSection from "../components/HomePage/FAQSection";
import CallToAction from "../components/HomePage/CallToAction";
import AIDemoSection from "../components/HomePage/AIDemoSection";
import "../components/HomePage/HomeRefresh.css";



const Home = () => {
  return (
    <div className="boxed_wrapper ltr">
      <Banner></Banner>
      <ServicesSection></ServicesSection>
      <AIDemoSection></AIDemoSection>
      <AboutSection></AboutSection>
      <PricingSection></PricingSection>
      <FAQSection></FAQSection>
      <TestimonialSection></TestimonialSection>
      <div className="modern-contact-section">
        <ContactUs></ContactUs>
      </div>
      <CallToAction></CallToAction>
    </div>
  );
};

export default Home;
